import React from 'react';
import { connect } from 'react-redux';

import { screen } from '$fcomponents/hoc';
import { ItemReportMain } from './itemReportMain';

interface itemReportScreenProps {
  factory;
  history;
  match;
  stores;
  columns;
  dateFilter;
}

const ItemReportScreen: React.FC<itemReportScreenProps> = ({
  history,
  columns,
  dateFilter,
  stores,
  match,
  factory,
}) => {
  return (
    <ItemReportMain
      history={history}
      columns={columns}
      dateFilter={dateFilter}
      stores={stores}
      factory={factory}
      match={match}
    />
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  stores: state.store.stores,
  columns: state.localStorage.columns,
});

const mapDispatchToProps = {};

const connected: any = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(ItemReportScreen));
